import { useDispatch, useSelector } from 'react-redux';
import { useRequestSections } from '../api/request';
import { useMutation } from '@tanstack/react-query';
import { RootState } from '../redux/Store';
import { Permissions } from '../constants';
import { decodeUnzip } from '../components/Decryption/Decryption';
import { updateInspectionSidebarLanguagePack } from '../redux/reducer/languageReducer';
import { useFindPermissions } from '../utils/helpers/useFindPermissions';
import { checkPermission } from '../utils';
import Notifications from '../ui/molecules/toast/Notifications';

const useLanguagePackTermsetModuleLanguagePack = () => {
  const dispatch = useDispatch();

  const { LanguagePackTermsetModule } = useRequestSections();
  const { canViewLanguagePack } = useFindPermissions();

  const {
    mutateAsync: getLanguagePackTermsetModule,
    data: languagePackTermsetModule,
    isPending: languagePackTermsetModulePending,
    isSuccess: languagePackTermsetModuleSuccessful,
    isError: languagePackTermsetModuleError,
  } = useMutation({
    mutationFn: async () => {
      if (canViewLanguagePack) {
        const response =
          await LanguagePackTermsetModule?.getLanguagepackTermsetsByModule();
        const result = response?.data?.languagePackValueGzip;

        if (result) {
          const decodedValue = decodeUnzip(result);
          dispatch(updateInspectionSidebarLanguagePack(decodedValue));
        }

        return result;
      }
      //  else
      //   return Notifications(
      //     'You do not have permission to view language pack',
      //     0
      //   );
    },
  });
  return {
    getLanguagePackTermsetModule,
    languagePackTermsetModule,
    languagePackTermsetModulePending,
    languagePackTermsetModuleSuccessful,
    languagePackTermsetModuleError,
  };
};

export default useLanguagePackTermsetModuleLanguagePack;
